<template>
    <div class="card-body">
        <h4 class="text-muted text-center">
            {{ $t('message.connections.message.macAddress') }}
        </h4>
        <div class="text-center">
            <text-field :label="$t('message.connections.message.mac')"
                          name="MAC"
                          v-model="val.mac"
                          :disabled="isEdit"
                          validate="required"
                          :error-messages="errors.collect($t('message.generics.message.ip'))"
                          @input="$emit('input', val)"></text-field>

            <app-select v-model="val.action"
                        :data-title="$t('message.connections.message.action')"
                        :data-search="false"
                        :data-items="actions"
                        :error-messages="errors.collect($t('message.connections.message.action'))"
                        :clearable="false"/>
           
        </div>
    </div>
</template>

<script>
    import AppSelect from '@components/Select'
    import TextField from '../../../../../../components/form/TextField.vue'
    import vModel from '@mixins/v-model'

    export default {
        components: {
    AppSelect,
    TextField,
},

        data() {
            return {                          
            }
        },

        props: {
            isEdit: {
                type: Boolean,
                default: false,
            },
        },        

        methods: {

            async validate() {
               const isValid = await this.$validator.validateAll()                
                if(isValid)
                    this.$emit('valid')
            },

        },

        computed: {
            actions() {
                return [
                    {id: 'RELEASE', label: this.$t('message.overview.message.cleared')},
                    {id: 'BLOCK', label: this.$t('message.overview.message.blocked')},
                ]
            }
        },

        mixins: [vModel],

    }

</script>

<style lang="scss" scoped>
    @import "~@variables";

    .card-body {
        padding: 18px 50px 10px;

        .v-input {
            margin: 12px 0 10px 0;
        }

        .text-center {
            .select {
                margin: 0 auto;
            }
        }

    }
</style>
